import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { practiceAPI } from '../../api';
import { Sidebar } from './dashboard_component';

const AiSets = () => {
  const navigate = useNavigate();
  const [sets, setSets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAISets();
  }, []);

  const fetchAISets = async () => {
    try {
      setLoading(true);
      const res = await practiceAPI.getAISets();
      setSets(res.data);
    } catch (error) {
      toast.error('Failed to load AI-generated sets');
    } finally {
      setLoading(false);
    }
  };

  const startPractice = (setId) => navigate(`/participate/preparena/practice/${setId}`);
  const deleteSet = async (setId, title) => {
    if (!window.confirm(`Delete "${title}"?`)) return;
    await practiceAPI.deleteSet(setId);
    toast.success('Deleted');
    fetchAISets();
  };

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-50 to-blue-50/30">
      <Sidebar isCollapsed={false} onToggle={() => {}} />
      <div className="flex-1 transition-all duration-300 pt-16 lg:pt-8 lg:ml-64">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl shadow-lg overflow-hidden mb-8">
            <div className="px-6 py-8">
              <h2 className="text-2xl font-bold text-white">AI-Generated Sets</h2>
              <p className="text-purple-100">Your practice sets created with AI assistance.</p>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            {loading ? (
              <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div></div>
            ) : sets.length === 0 ? (
              <div className="text-center py-12">
                <p className="text-gray-500">No AI-generated sets yet.</p>
                <a href="/participate/smartgen" className="mt-4 inline-block bg-purple-600 text-white px-6 py-2 rounded-lg hover:bg-purple-700">Go generate some</a>
              </div>
            ) : (
              <div className="divide-y divide-gray-200">
                {sets.map(set => (
                  <div key={set.set_id} className="p-6 hover:bg-gray-50 transition flex justify-between items-center">
                    <div>
                      <h3 className="text-lg font-semibold">{set.title}</h3>
                      <p className="text-sm text-gray-500">{set.total_questions} questions</p>
                    </div>
                    <div className="flex gap-3">
                      <button onClick={() => startPractice(set.set_id)} className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700">Practice</button>
                      <button onClick={() => deleteSet(set.set_id, set.title)} className="bg-red-100 text-red-700 px-3 py-2 rounded-lg hover:bg-red-200">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiSets;